import PageTitle from "@components/PageTitle";
import SearchPartner from "@components/SearchPartner";
import "./style.scss";

const ContactSection = () => {
	return (
		<section className="contact-section">
			<div className="contact-section__inner">
				<PageTitle title="PARTNER" subTitle="뷰아드 필름 시공점을 확인해보세요." noBorder />
				<SearchPartner noMap={{ mobile: true }} />
			</div>
		</section>
	);
};

export default ContactSection;
